// Build info - generated at build time by vite.config.owner.js
// This file is auto-generated - do not edit manually
export const BUILD_SHA = '79578ed0';
export const BUILD_TIME = '2026-10-28 19:42 PT';
